import { CircleHelp, Expand, Shrink } from "lucide-react";

import { FloatingControlsHelpPanel } from "@/components/viewer/FloatingControlsHelpPanel";
import { ViewerCompass } from "@/components/viewer/ViewerCompass";
import { ViewerZoomControls } from "@/components/viewer/ViewerZoomControls";
import type { PixatwinViewerOverlayContributionProps } from "@/sdk";

export const CoreViewerOverlayControls = ({
  controlsHelp,
  fullscreenToggleLabel,
  initialCameraPose,
  isViewerFullscreen,
  offsetLeftPx,
  offsetRightPx,
  onToggleFullscreen,
  shouldHideViewerPanels,
  viewer,
}: PixatwinViewerOverlayContributionProps) => {
  return (
    <>
      <ViewerCompass viewer={viewer} offsetLeftPx={offsetLeftPx} />
      {!shouldHideViewerPanels ? (
        <ViewerZoomControls
          viewer={viewer}
          offsetLeftPx={offsetLeftPx}
          initialCameraPose={initialCameraPose}
        />
      ) : null}
      {!shouldHideViewerPanels ? (
        <button
          type="button"
          onClick={onToggleFullscreen}
          className="absolute z-[9997] flex h-16 w-16 cursor-pointer items-center justify-center rounded-2xl border border-white/25 bg-slate-950/28 text-white/92 shadow-[0_8px_18px_rgba(15,23,42,0.22)] backdrop-blur-md transition-transform hover:scale-[1.03] hover:bg-slate-950/34 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
          style={{
            top: "calc(var(--viewer-topbar-height, 80px) + 16px)",
            right: `${offsetRightPx}px`,
            transition:
              "right 300ms ease, top 300ms ease, transform 200ms ease, background-color 200ms ease",
          }}
          aria-label={fullscreenToggleLabel}
          title={fullscreenToggleLabel}
        >
          <span className="flex h-11 w-11 items-center justify-center drop-shadow-[0_4px_10px_rgba(15,23,42,0.3)]">
            {isViewerFullscreen ? (
              <Shrink className="h-7 w-7" strokeWidth={1.9} />
            ) : (
              <Expand className="h-7 w-7" strokeWidth={1.9} />
            )}
          </span>
        </button>
      ) : null}
      {!shouldHideViewerPanels ? (
        <>
          <button
            ref={(element) => {
              controlsHelp.triggerRef.current = element;
            }}
            type="button"
            onClick={() => controlsHelp.onOpenChange(true)}
            className="absolute z-[9997] flex h-16 w-16 cursor-pointer items-center justify-center rounded-2xl border border-white/25 bg-slate-950/28 text-white/92 shadow-[0_8px_18px_rgba(15,23,42,0.22)] backdrop-blur-md transition-transform hover:scale-[1.03] hover:bg-slate-950/34 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
            style={{
              bottom:
                "calc(max(var(--viewer-bottombar-height, 96px), 96px) + 20px + env(safe-area-inset-bottom, 0px))",
              right: `${offsetRightPx}px`,
              transition:
                "right 300ms ease, bottom 300ms ease, transform 200ms ease, background-color 200ms ease",
            }}
            aria-label="Afficher l'aide des contrôles"
            title="Afficher l'aide des contrôles"
          >
            <span className="flex h-11 w-11 items-center justify-center drop-shadow-[0_4px_10px_rgba(15,23,42,0.3)]">
              <CircleHelp className="h-7 w-7" strokeWidth={1.9} />
            </span>
          </button>

          <FloatingControlsHelpPanel
            open={controlsHelp.open}
            onOpenChange={controlsHelp.onOpenChange}
            triggerRef={controlsHelp.triggerRef}
            title="Contrôles de navigation 3D"
            panelWidthPx={200}
            panelHeightPx={310}
            offsetX={69}
            offsetY={-6}
          >
            <div className="relative h-full w-full">
              <img
                src="/assets/PIXAtwin_Controls.png"
                alt="Contrôles de navigation 3D"
                className="h-full w-full object-contain"
              />
            </div>
          </FloatingControlsHelpPanel>
        </>
      ) : null}
    </>
  );
};
